
import styles from "./cardHeader.module.css";

export function CardHeader({ text }) {
  return <h3 className={styles.header}>{text}</h3>;
}
